import { IState } from '@redux/reducer';
import {
  ICareTeamRole,
  FETCH_APP_USER_CARE_TEAM,
  FETCH_APP_USER_CARE_TEAM_SUCCESS,
  FETCH_APP_USER_CARE_TEAM_FAILED,
  FETCH_APP_USER_PATHWAY_CARE_TEAM,
  FETCH_APP_USER_PATHWAY_CARE_TEAM_SUCCESS,
  FETCH_APP_USER_PATHWAY_CARE_TEAM_FAILED,
  CREATE_CARE_TEAM_ROLE,
  CREATE_CARE_TEAM_ROLE_SUCCESS,
  CREATE_CARE_TEAM_ROLE_FAILED,
  CREATE_CARE_TEAM_ROLE_MEMBER,
  CREATE_CARE_TEAM_ROLE_MEMBER_SUCCESS,
  CREATE_CARE_TEAM_ROLE_MEMBER_FAILED,
  CREATE_CARE_TEAM_ROLE_AND_MEMBER,
  CREATE_CARE_TEAM_ROLE_AND_MEMBER_SUCCESS,
  CREATE_CARE_TEAM_ROLE_AND_MEMBER_FAILED,
  EDIT_CARE_TEAM_ROLE_MEMBER,
  EDIT_CARE_TEAM_ROLE_MEMBER_SUCCESS,
  EDIT_CARE_TEAM_ROLE_MEMBER_FAILED,
  DELETE_CARE_TEAM_ROLE,
  DELETE_CARE_TEAM_ROLE_SUCCESS,
  DELETE_CARE_TEAM_ROLE_FAILED,
  DELETE_CARE_TEAM_ROLE_MEMBER,
  DELETE_CARE_TEAM_ROLE_MEMBER_SUCCESS,
  DELETE_CARE_TEAM_ROLE_MEMBER_FAILED,
} from './types';
import {
  IFetchAppUserCareTeam,
  IFetchAppUserCareTeamSuccess,
  IFetchAppUserCareTeamFailed,
  IFetchAppUserPathwayCareTeam,
  IFetchAppUserPathwayCareTeamSuccess,
  IFetchAppUserPathwayCareTeamFailed,
  ICreateCareTeamRole,
  ICreateCareTeamRoleSuccess,
  ICreateCareTeamRoleFailed,
  ICreateCareTeamRoleMember,
  ICreateCareTeamRoleMemberSuccess,
  ICreateCareTeamRoleMemberFailed,
  ICreateCareTeamRoleAndMember,
  ICreateCareTeamRoleAndMemberSuccess,
  ICreateCareTeamRoleAndMemberFailed,
  IEditCareTeamRoleMember,
  IEditCareTeamRoleMemberSuccess,
  IEditCareTeamRoleMemberFailed,
  IDeleteCareTeamRole,
  IDeleteCareTeamRoleSuccess,
  IDeleteCareTeamRoleFailed,
  IDeleteCareTeamRoleMember,
  IDeleteCareTeamRoleMemberSuccess,
  IDeleteCareTeamRoleMemberFailed,
} from './actions';

type ICareTeamState = {
  appUserRoles: { [appUserId: string]: ICareTeamRole[] };
  appUserPathwayRoles: { [appUserId: string]: { [appUserPathwayId: string]: ICareTeamRole[] } };
  loading: boolean;
};

const initialState: ICareTeamState = {
  appUserRoles: {},
  appUserPathwayRoles: {},
  loading: false,
};

const careTeam = (
  state: ICareTeamState = initialState,
  action:
    | IFetchAppUserCareTeam
    | IFetchAppUserCareTeamSuccess
    | IFetchAppUserCareTeamFailed
    | IFetchAppUserPathwayCareTeam
    | IFetchAppUserPathwayCareTeamSuccess
    | IFetchAppUserPathwayCareTeamFailed
    | ICreateCareTeamRole
    | ICreateCareTeamRoleSuccess
    | ICreateCareTeamRoleFailed
    | ICreateCareTeamRoleMember
    | ICreateCareTeamRoleMemberSuccess
    | ICreateCareTeamRoleMemberFailed
    | ICreateCareTeamRoleAndMember
    | ICreateCareTeamRoleAndMemberSuccess
    | ICreateCareTeamRoleAndMemberFailed
    | IEditCareTeamRoleMember
    | IEditCareTeamRoleMemberSuccess
    | IEditCareTeamRoleMemberFailed
    | IDeleteCareTeamRole
    | IDeleteCareTeamRoleSuccess
    | IDeleteCareTeamRoleFailed
    | IDeleteCareTeamRoleMember
    | IDeleteCareTeamRoleMemberSuccess
    | IDeleteCareTeamRoleMemberFailed,
) => {
  switch (action.type) {
    case FETCH_APP_USER_CARE_TEAM:
      return {
        ...state,
        loading: true,
      };
    case FETCH_APP_USER_CARE_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        appUserRoles: {
          ...state.appUserRoles,
          [action.payload.appUserId]: action.payload.appUserRoles,
        },
      };
    case FETCH_APP_USER_CARE_TEAM_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FETCH_APP_USER_PATHWAY_CARE_TEAM:
      return {
        ...state,
        loading: true,
      };
    case FETCH_APP_USER_PATHWAY_CARE_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        appUserPathwayRoles: {
          ...state.appUserPathwayRoles,
          [action.payload.appUserId]: {
            ...state.appUserPathwayRoles[action.payload.appUserId],
            [action.payload.appUserPathwayId]: action.payload.appUserPathwayRoles,
          },
        },
      };
    case FETCH_APP_USER_PATHWAY_CARE_TEAM_FAILED:
      return {
        ...state,
        loading: false,
      };
    case CREATE_CARE_TEAM_ROLE:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CARE_TEAM_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        appUserRoles: {
          ...state.appUserRoles,
          [action.payload.appUserId]: [
            ...state.appUserRoles[action.payload.appUserId],
            action.payload.role,
          ],
        },
      };
    case CREATE_CARE_TEAM_ROLE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case CREATE_CARE_TEAM_ROLE_MEMBER:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CARE_TEAM_ROLE_MEMBER_SUCCESS: {
      const { appUserId, roleId, member, appUserPathwayId } = action.payload;
      const updateRoles = (roles: ICareTeamRole[]) =>
        roles.map(role =>
          role.id === roleId ? { ...role, members: [...role.members, member] } : role,
        );

      return {
        ...state,
        loading: false,
        appUserRoles: {
          ...state.appUserRoles,
          [appUserId]: state.appUserRoles[appUserId]
            ? updateRoles(state.appUserRoles[appUserId])
            : [],
        },
        ...(appUserPathwayId && {
          appUserPathwayRoles: {
            ...state.appUserPathwayRoles,
            [appUserId]: {
              ...state.appUserPathwayRoles[appUserId],
              [appUserPathwayId]: state.appUserPathwayRoles[appUserId]?.[appUserPathwayId]
                ? updateRoles(state.appUserPathwayRoles[appUserId][appUserPathwayId])
                : [],
            },
          },
        }),
      };
    }
    case CREATE_CARE_TEAM_ROLE_MEMBER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case CREATE_CARE_TEAM_ROLE_AND_MEMBER:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CARE_TEAM_ROLE_AND_MEMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        appUserRoles: {
          ...state.appUserRoles,
          [action.payload.appUserId]: [
            ...state.appUserRoles[action.payload.appUserId],
            action.payload.roleWithMember,
          ],
        },
      };
    case CREATE_CARE_TEAM_ROLE_AND_MEMBER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case EDIT_CARE_TEAM_ROLE_MEMBER:
      return {
        ...state,
        loading: true,
      };
    case EDIT_CARE_TEAM_ROLE_MEMBER_SUCCESS: {
      const { appUserId, roleId, careTeamMemberId, member, appUserPathwayId } = action.payload;
      const updateRoles = (roles: ICareTeamRole[]) =>
        roles.map(role =>
          role.id === roleId
            ? {
                ...role,
                members: role.members.map(m => (m.id === careTeamMemberId ? member : m)),
              }
            : role,
        );

      return {
        ...state,
        loading: false,
        appUserRoles: {
          ...state.appUserRoles,
          [appUserId]: state.appUserRoles[appUserId]
            ? updateRoles(state.appUserRoles[appUserId])
            : [],
        },
        ...(appUserPathwayId && {
          appUserPathwayRoles: {
            ...state.appUserPathwayRoles,
            [appUserId]: {
              ...state.appUserPathwayRoles[appUserId],
              [appUserPathwayId]: state.appUserPathwayRoles[appUserId]?.[appUserPathwayId]
                ? updateRoles(state.appUserPathwayRoles[appUserId][appUserPathwayId])
                : [],
            },
          },
        }),
      };
    }
    case EDIT_CARE_TEAM_ROLE_MEMBER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case DELETE_CARE_TEAM_ROLE:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CARE_TEAM_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        appUserRoles: {
          ...state.appUserRoles,
          [action.payload.appUserId]: state.appUserRoles[action.payload.appUserId].filter(
            role => role.id !== action.payload.careTeamRoleId,
          ),
        },
      };
    case DELETE_CARE_TEAM_ROLE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case DELETE_CARE_TEAM_ROLE_MEMBER:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CARE_TEAM_ROLE_MEMBER_SUCCESS: {
      const { appUserId, roleId, careTeamMemberId, appUserPathwayId } = action.payload;
      const updateRoles = (roles: ICareTeamRole[]) =>
        roles.map(role =>
          role.id === roleId
            ? {
                ...role,
                members: role.members.filter(m => m.id !== careTeamMemberId),
              }
            : role,
        );

      return {
        ...state,
        loading: false,
        appUserRoles: {
          ...state.appUserRoles,
          [appUserId]: state.appUserRoles[appUserId]
            ? updateRoles(state.appUserRoles[appUserId])
            : [],
        },
        ...(appUserPathwayId && {
          appUserPathwayRoles: {
            ...state.appUserPathwayRoles,
            [appUserId]: {
              ...state.appUserPathwayRoles[appUserId],
              [appUserPathwayId]: state.appUserPathwayRoles[appUserId]?.[appUserPathwayId]
                ? updateRoles(state.appUserPathwayRoles[appUserId][appUserPathwayId])
                : [],
            },
          },
        }),
      };
    }
    case DELETE_CARE_TEAM_ROLE_MEMBER_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default careTeam;

export const selectAppUserCareTeam = (appUserId: string) => (state: IState) => [
  state.careTeam.loading,
  state.careTeam.appUserRoles[appUserId] ?? [],
];

export const selectAppUserPathwayCareTeam = (appUserId: string, appUserPathwayId: string) => (
  state: IState,
) => [
  state.careTeam.loading,
  state.careTeam.appUserPathwayRoles[appUserId]?.[appUserPathwayId] ?? [],
];

export const selectAppUserCareTeamRole = (appUserId: string, roleId: number) => (state: IState) =>
  state.careTeam.appUserRoles[appUserId]?.find(role => role.id === roleId) ?? null;
